module.exports = __webpack_public_path__ + "static/media/view4.d32be0dd.jpg";